module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA2CAYAAADQzyn5AAAABHNCSVQICAgIfAhkiAAAAQtJREFUWEfd2U0OgyAQBeCS3s4LdNHzddELeLvGZoyaqijz896YlM0QFnwMbIApt6n1ff+Qbtd173mMGYtMLmgp5SX9YRieGXj5Qe9Thp8MvAaLT8e3Wz1nTcdHeHPOKfgCZ+MrOBPfwVl4Fc7AD2E2fgoz8SbMwlUwA1fDaNwEI3EzjMJdMAJ3w1E8BEfwMOzFIbAHh8FWHApbcDisxSmwBqfBLfz/4MoLZXVXp2TcQmUFcFiDwmEtCoUtKAy2ohDYg4ZhLxqCI6gbjqIuGIGaYRRqgpGoGkajKpiBNmEWegoz0UOYjVbhDHQHZ6ErOBNd4Gx0hK9Aj2D6X3Vtq/NKA6LPzw2JGfUIcb4mw9c4MjElmgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/pC/prev-1.png
// module id = 186t
// module chunks = 1